/**
 * filter class to abstract filter logic from the search logic. A filter
 * comes with a set of standard behaviors for variable changes and others.
 * All of these standard bewhaviors can be individually overriden.
 *
 * At the core of the filter is its value (filter.value). The search library
 * will never directly access this value, but will only use the getValue and
 * setValue methods. This behavior is on purpose, so that we have more freedom
 * in binding to the filter.value from ui directives etc. which might behave
 * in weird ways.
 *
 * Overridable
 * functions are
 *  - isActive: When this returns true, the filter will be included in url calls
 *              to the back-end. When it returns false, it is ommited
 *  - getValue: Returns the value of the filter as it should be passed to the
 *              back-end. For example, one could return an object, even-though
 *              the value is an integer. Can return any serializable value.
 *  - setValue: Accepts any value and takes care of updating the filter.value.
 *              It should be the inverse of getValue.
 *  - containsValue: Accepts any value and check in the filter array if the value is
 *              present or not OR check if value is equal to filter.
 *              Returns a boolean.
 *  - reset:    Should take care of resetting the value to its original state.
 */

devex = devex || {};
devex.search = devex.search || {};

devex.search.Filter = function (options) {
  var defaultOptions = {
    // isArray will make the default value handler
    // return or accept arrays
    isArray: false,
    // when true, value gets attached to root instead of inside
    // the "filter" object
    attachToRoot: false,
    // when allowDuplicates is set to false and if the filter value is an array,
    // the addValue method will push the value to the filter array
    // only if it's not already present in the array.
    // Not that this property ONLY works if the setValue and getValue of the filter are not being
    // overwritten when we register the filter on SearchJS
    allowDuplicates: true,
    // when this method returns true, the value will be included
    // in the serialization for urls or back-end queries
    isActive: function () {
      return !!(
        (this.value || typeof this.value === 'boolean')
        && !(Array.isArray(this.value) && this.value.length === 0)
        && !_.isEqual(this.value, this.default)
      );
    },
    // should return a serializable object
    getValue: function () {
      var value = this.value;
      if (this.isArray && !Array.isArray(value)) {
        value = [value];
      }
      return value;
    },
    // should return a serializable object (used for back-end
    // queries
    getValueForBackend: function () {
      return this.getValue();
    },
    // receives an object and is responsible for setting the value
    // correctly
    setValue: function (queryParam) {
      if (this.isArray) {
        if (!Array.isArray(queryParam)) {
          queryParam = [queryParam];
        }
      }
      this.value = queryParam;
    },
    /**
     * Check if value is present in array or if value is
     * equal to current filter.
     *
     * @param {object} value
     * @returns {boolean}
     */
    containsValue: function (value) {
      if (this.isArray) {
        return this.value.indexOf(value) > -1;
      } else {
        return value === this.value;
      }
    },
    // for arrays only. should add another filter value to the array
    addValue: function (value) {
      if (!this.allowDuplicates && this.isArray) {
        if (this.value.indexOf(value) == -1) {
          this.value.push(value);
        }
      } else {
        this.value.push(value);
      }
    },
    // for arrays only. should remove a filter value
    removeValue: function (value) {
      var index = this.value.indexOf(value);
      this.value.splice(index, 1);
      return value;
    },
    // reset the filter to its initial state
    reset: function () {
      if (Array.isArray(this.default)) {
        this.value = this.default.slice();
      } else {
        this.value = _.clone(this.default);
      }
    }
  };

  _.extend(this, defaultOptions, options);

  if (!this.default && this.default !== false && this.isArray) {
    this.default = [];
  }

  if (!this.name) {
    throw 'name for filter is missing';
  }
  if (!this.paramName) {
    this.paramName = this.name;
  }

  this.reset();

  return this;
};

devex.search.Filter.prototype.valueToString = function (value) {
  if (typeof value === 'object') {
    return value.name;
  }
  return value;
};

